// !!!!!!!!!!!!!! TODO: this file deprecated, please use renderers from src\ui\widgets\Table\formatters
export const getNullTextMapper = (field: string) => {
  let value = "Empty";
  switch (field) {
    case "fileKey": {
      value = "Ungenerated";
    }
  }
  return value;
};